import React from 'react'
import { Avatar, Button, Card, Space, Typography } from 'antd'
import { ArrowRightOutlined } from '@ant-design/icons'
import { EnvironmentType } from '../index'
import { breakpoints, getWindowSize } from '../../../../helpers/windowSize'
import { getAvatarInitials } from '../../../../helpers/avatar'

import { UserGroupMappedType } from '../../../../helpers/groups'

interface AccountSelectionProps {
  environment: EnvironmentType
  onAccountSelect: (account: UserGroupMappedType) => void
}

const { Text } = Typography

export const AccountSelection: React.FC<AccountSelectionProps> = ({ environment, onAccountSelect }) => {
  if (!environment) return null

  const { innerWidth } = getWindowSize()

  return (
    <Space direction="vertical" size="middle" style={{ width: '100%', paddingBottom: innerWidth < breakpoints.md ? '12px' : '24px' }}>
      <Space direction="vertical" size="small" style={{ width: '100%' }}>
        {environment.accounts.map((account: UserGroupMappedType) => (
          <Card
            styles={{ body: { backgroundColor: '#FCFEFF', borderRadius: '8px' } }}
            size="small"
            key={account.id}
            hoverable
            style={{ cursor: 'pointer', borderColor: '#DCE7F2' }}
            onClick={() => onAccountSelect(account)}
          >
            <Space style={{ width: '100%', justifyContent: 'space-between' }}>
              <Space>
                <Avatar style={{ backgroundColor: environment.color, color: '#fff' }} size="large">
                  {getAvatarInitials(account.userName)}
                </Avatar>
                <div>
                  <div style={{ fontWeight: 600, fontSize: '16px' }}>{account.userName}</div>
                  <Text strong style={{ fontSize: '14px', color: environment.color }}>
                    {account.groupName}
                  </Text>
                  <div style={{ marginBottom: '4px' }}>
                    <Text type="secondary" style={{ fontSize: '14px', color: '#303443' }}>
                      {account.superGroup}
                    </Text>
                  </div>
                  <Text type="secondary" style={{ fontSize: '13px', color: '#303443' }}>
                    {account.userEmail}
                  </Text>
                </div>
              </Space>
              <Button>
                <ArrowRightOutlined style={{ color: '#3D87C5' }} />
              </Button>
            </Space>
          </Card>
        ))}
      </Space>
    </Space>
  )
}
